import axios from "axios";

const instance = axios.create({
  baseURL: "https://libravaluer.com/librabackend/public/api/",
  // baseURL: "https://lvpl.in/librabackend/public/api/",
  // baseURL: "https://libravaluer.com/librabackend/public/api/",
});

export default instance;
  